<template>
  <v-card>
    <v-card-title class="primary white--text font-weight-bold justify-center">
      <span class="ml-2">{{ title }}</span>
    </v-card-title>
    <v-card-text
      class="overflow-y-auto"
      style="height:400px; max-height: 400px;"
      @drop="drop($event)"
      @dragover.prevent
    >
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        class="pb-4"
        color="third"
        @click.stop
      />
      <div class="full-height">
        <ul>
          <li
            v-for="product in productsList"
            :key="product.uuid"
            :class="[{'lightBlue-bg':product.isSelected}, {'pointer-events-none': disabled}, 'd-flex align-center justify-center table-line pointer']"
            style="border-bottom: 1px solid lightgrey"
            :draggable="productsList.every(p => !p.isSelected)"
            @dragstart="dragStart($event, product)"
            @dragover.prevent
            @click="selectProduct(product)"
            @dblclick="updateProduct(product)"
          >
            <v-row no-gutters>
              <v-col cols="12" class="d-flex justify-center">
                <span class="ml-4">{{ product.name }}</span>
              </v-col>
            </v-row>
          </li>
        </ul>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      default: null
    },
    products: {
      type: Array,
      default: () => []
    },
    dropElement: {
      type: String,
      default: null
    },
    selected: {
      type: String,
      default: null
    },
    updateCustomerProduct: {
      type: Function,
      default: null
    },
    updateSelectedProducts: {
      type: Function,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return { search: null };
  },
  computed: {
    productsList () {
      let { products } = this.$props;

      if (this.search) {
        products = products.filter(p => p.name.toLowerCase().includes(this.search.toLowerCase()));
      }
      return products;
    }
  },
  methods: {
    dragStart (event, product) {
      event.dataTransfer.setData('product_uuid', product.uuid);
      event.dataTransfer.setData('element_type', this.$props.dropElement);
    },
    drop (event) {
      const productUuid = event.dataTransfer.getData('product_uuid');
      const elementType = event.dataTransfer.getData('element_type');

      if (elementType === this.$props.dropElement) {
        EventBus.$emit('show-notifications', [{
          message: 'Impossible de glisser-déposer sur la même colonne',
          type: 'danger'
        }]);
        return;
      }
      // update
      this.updateCustomerProduct(productUuid, elementType);
    },
    selectProduct (product) {
      product.isSelected = !product.isSelected;

      if (product.isSelected) {
        const action = 'add';
        this.updateSelectedProducts(this.$props.selected, product, action);
        return;
      }

      const action = 'splice';
      this.updateSelectedProducts(this.$props.selected, product, action);
    },
    updateProduct (product) {
      this.updateCustomerProduct(product.uuid, this.$props.dropElement);
    }
  }
};
</script>

<style>
  .lightBlue-bg {
    background-color: lightblue;
  }

  .table-line {
    height: 40px;
    font-size: 16px;
  }

  .pointer-events-none {
    pointer-events: none;
    opacity: 0.7;
  }
</style>
